const ITEMS = [
  "TRANSMITIENDO EN VIVO",
  "LAS BREÑAS · CHACO",
  "96.3 MHz FM",
  "LA RADIO DE LA CIUDAD",
  "MÚSICA Y COMPAÑÍA",
  "LAS BREÑAS DIGITAL",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative py-4 bg-[#0D131E] border-y border-cyan-500/20 overflow-hidden">
      <div className="flex whitespace-nowrap marquee-track">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="mx-6 text-xs sm:text-sm font-mono tracking-[0.25em] text-cyan-400/90 uppercase">
              {item}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400/70" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default EditorialMarquee;
